import ToggleDesign from './ToggleDesign.vue';

export { ToggleDesign };
export default ToggleDesign;
